import React from 'react';
import HeartIcon from './HeartIcon';
import BookmarkIcon from './BookmarkIcon';
import SubscriptionBlur from './SubscriptionBlur';
import { useAuth } from '../context/AuthContext';
import './ArticleCard.css';

const ArticleCard = ({ article, isFavorite, isReadLater, onFavorite, onReadLater, onClick, showTags = {}, readArticles = {}, lastLogin, onPatentLinkRestricted, tagStylePreference = 'colored' }) => {
  const { currentUser } = useAuth();
  const plan = currentUser?.plan || 'none';
  const isLocked = !currentUser || plan === 'none';
  const isNeutralStyle = tagStylePreference === 'neutral';

  // Restrictions removed - all users can see everything
  const isPatent = article.Type === 'Patent';
  const shouldBlur = false;

  const handleLinkClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // If it's a patent and user is on free plan, show upgrade modal
    if (isPatent && isLocked) {
      if (onPatentLinkRestricted) {
        onPatentLinkRestricted();
      }
    } else {
      // Otherwise, open the link normally
      window.open(article.Link, '_blank', 'noopener,noreferrer');
    }
  };

  // Dates formatées
  const dateAjout = article.createdAt ? new Date(article.createdAt).toLocaleDateString('fr-FR') : '-';
  const datePubli = article.year_of_publication || '-';

  return (
    <div className="article-card" onClick={onClick}>
      {article.Picture && (
        <SubscriptionBlur isLocked={shouldBlur}>
          <div className="article-card-image">
            <img src={article.Picture} alt={article.Title} />
          </div>
        </SubscriptionBlur>
      )}
      <div className="article-card-content">
        <h3 className="article-card-title" style={{marginTop: 0}}>{article.Title}</h3>
        {article.short_resume && <div className="article-card-resume">{article.short_resume}</div>}
        <div className="article-card-tags">
          {showTags.OEM !== false && article.OEM && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-oem'}`}>{article.OEM}</span>}
          {showTags.brand !== false && article.brand && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-brand'}`}>{article.brand}</span>}
          {showTags.car_model !== false && article.car_model && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-car-model'}`}>{article.car_model}</span>}
          {showTags.System !== false && article.System && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-system'}`}>{article.System}</span>}
          {showTags.subsystem !== false && (article.subsystem || article.Subsystem) && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-subsystem'}`}>{article.subsystem || article.Subsystem}</span>}
          {showTags.part !== false && article.part && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-part'}`}>{article.part}</span>}
          {showTags.Type !== false && article.Type && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-type'}`}>{article.Type}</span>}
          {showTags.Material !== false && article.material && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-material'}`}>{article.material}</span>}
          {showTags.technology !== false && article.technology && <span className={`tag ${isNeutralStyle ? 'tag-neutral' : 'tag-technology'}`}>{article.technology}</span>}
        </div>
        <div className="article-card-actions-row">
          <div className="article-card-actions">
            {/* 1. Favorites */}
            <button className="icon-btn" onClick={e => { e.stopPropagation(); onFavorite && onFavorite(article); }} title="Favori">
              <HeartIcon filled={isFavorite} />
            </button>
            {/* 2. Read later */}
            <button className="icon-btn" onClick={e => { e.stopPropagation(); onReadLater && onReadLater(article); }} title="A lire">
              <BookmarkIcon filled={isReadLater} />
            </button>
            {/* 3. Read/Unread status */}
            {(() => {
              const isRead = Boolean(article.isRead || readArticles[article._id] || readArticles[article.ID]);
              return (
                <button
                  className={`icon-btn icon-btn-read ${isRead ? 'is-read' : 'is-unread'}`}
                  onClick={(e) => { e.stopPropagation(); }}
                  title={isRead ? 'Marquer comme non lu' : 'Marquer comme lu'}
                  style={{ cursor: 'default' }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.6" fill={isRead ? 'currentColor' : 'none'} />
                  </svg>
                </button>
              );
            })()}
            {/* 4. Link */}
            {article.Link && (
              <a href={article.Link} target="_blank" rel="noopener noreferrer" className="icon-btn" onClick={handleLinkClick} title="Ouvrir le lien">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M14 4H20V10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10 14L20 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M20 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleCard;
